import Trans from 'next-translate/Trans'
import React, { useCallback } from 'react'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import DistanceInKm from 'tennders-common/components/DistanceInKM'
import useCompanyOpenDetails from 'tennders-company/details/hooks/useCompanyOpenDetails'
import GHref from 'tennders-market/common/components/element/GHref'
import useTransactionDetailStore from 'tennders-transactions/stores/useTransactionDetailStore'
import { useRouter } from 'next/router'
import DOMPurify from 'dompurify'
import dynamic from 'next/dynamic'
import useTranslation from 'next-translate/useTranslation'
import { STATUS_UNAVAILABLE, STATUS_DELETED } from 'tennders-stracture/libs/constants'
import useSession from 'tennders-auth/hooks/useSession'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsAltH, faXmark } from '@fortawesome/free-solid-svg-icons'

const EllipsisToolTip = dynamic(() => import('ellipsis-tooltip-react-chan'), { ssr: false })

const DetailHeader = (props) => {
  const {
    item,
    children,
    close
  } = props
  const [assignTruckLoadType] = useTransactionDetailStore(state => [state.assignTruckLoadType])
  const [transaction] = useTransactionDetailStore(state => [state.detail])
  const { openFor } = useCompanyOpenDetails()
  const { t } = useTranslation()
  const { pathname } = useRouter()
  const { isShipperUser, isCarrierUser } = useSession()

  const getTitle = useCallback(() => {
    if (pathname?.includes('loadboard') || (pathname === '/' && isShipperUser)) {
      return t('transaction:loadDetails')
    }
    if (pathname?.includes('truckboard') || (pathname === '/' && isCarrierUser)) {
      return t('transaction:truck_details')
    }
    if (pathname?.includes('loadboard')) {
      return t('transaction:loadDetails')
    }
    if (pathname?.includes('truckboard')) {
      return t('transaction:truck_details')
    }
    if (assignTruckLoadType === 'truck') {
      return t('transaction:assign_truck')
    }
    if (assignTruckLoadType === 'load') {
      return t('transaction:assign_load')
    }
    if (assignTruckLoadType === 'truck-match') {
      return t('transaction:matchTrucks')
    }
    if (assignTruckLoadType === 'load-match') {
      return t('transaction:matchLoads')
    }
    return t('transaction:transaction_details')
  }, [pathname, assignTruckLoadType, isShipperUser, isCarrierUser])

  return (
    <header className="detailed-header">
      <h2
        className="bold mb-0 border-r pr-12 mr-12 color-s"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(getTitle()) }}
      />
      <div className="border-r pr-12 mr-12">
        <div className="text-14 bold">
          {transaction?.referenceNumber}
        </div>
        <div className="text-11 color-light-gray">{item?.createdAt?.dT}</div>
      </div>
      <div className="text-center">
        <div className="text-14 bold">{transaction?.pickupRoute?.label}</div>
        <div className="text-11 color-light-gray">{transaction?.pickupRoute?.date?.f}</div>
      </div>
      <div className="mx-24 color-light-gray text-center lh-1">
        <div className="text-11"><DistanceInKm value={transaction?.distanceInKms} /></div>
        <FontAwesomeIcon icon={faArrowsAltH} fontSize={24} aria-hidden="true" />
        <div className="text-11"><DistanceInKm value={transaction?.emptyKms} /></div>
      </div>
      <div className="border-r pr-12 mr-12 text-center">
        {
          transaction?.deliveryRoute
            ? (
              <>
                <div className="text-14 bold">{transaction?.deliveryRoute?.label}</div>
                <div className="text-11 color-light-gray">{transaction?.deliveryRoute?.date?.f}</div>
              </>
            ) : (
              <div className="text-11 color-light-gray">
                <Trans i18nKey="transaction:notDefined" />
              </div>
            )
        }
      </div>
      {(item?.company?.name || item?.company?.pointOfContact?.email || item?.createdBy?.name) ? (
        <div className="border-r pr-12 mr-12 text-center load-truck-company-name">
          <div
            className="text-14 bold cursor-pointer"
            onClick={item?.company?.name ? () => openFor(item?.company?.id) : null}
          >
            <EllipsisToolTip options={{ className: 'custom-color-tooltip' }}>
              {item?.company?.name || ''}
            </EllipsisToolTip>
          </div>
          <div className="text-11 color-light-gray">
            <EllipsisToolTip options={{ className: 'custom-color-tooltip' }}>
              {item?.company?.pointOfContact?.email || item?.createdBy?.name || ''}
            </EllipsisToolTip>
          </div>
        </div>
      ) : null}
      <div className="border-r pr-20 mr-20 text-center">
        {item?.paymentTerm?.type || '-'}
      </div>
      <div className="border-r pr-20 mr-20 text-center">
        <div className="text-center  ">
          <div className="text-14 bold">
            { transaction?.status?.label === STATUS_UNAVAILABLE
              || transaction?.status?.label === STATUS_DELETED ? <span>N/A</span>
              : <GCurrency value={item?.bookRate || item?.targetPrice || transaction?.marketPrice} />}
          </div>
        </div>
      </div>
      <div className="border-r pr-20 mr-20 text-center">
        <div className="text-center">
          <div className="text-14">
            <Trans i18nKey={`variables:${transaction?.status?.label}`} />
          </div>
        </div>
      </div>
      {children && (
        <div className="text-center">
          <div className="text-14 d-flex justify-center align-center">
            {children}
          </div>
        </div>
      )}
      <span className="cursor-pointer" onClick={close} style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end', marginLeft: 'auto', marginRight: 20, maxWidth: 24 }}>
        <FontAwesomeIcon icon={faXmark} fontSize={25} />
      </span>
    </header>
  )
}
export default DetailHeader
